<template>
  <div class="container">
    <!-- 头部区域 -->
    <header>
      <div class="header_content"><span class="titTop">社会组织画像</span></div>
      <div class="goback"
           @click="goback">
        <img src="../../assets/socialOrg/goback.png"
             alt="" />
        <span>返回</span>
      </div>
    </header>
    <!-- 中部区域 -->
    <div class="center_box">
      <!-- 表格 -->
      <div class="table">
        <div class="bigrow">
          <div class="bigrow_tit1">{{ orgName }}</div>
          <div class="bigrow_tit2" v-if ="address != null">
            <img src="../../assets/socialOrg/smallimg.png"
                 alt="" />
            <span>{{ address }}</span>
          </div>
        </div>
        <div class="row"
             style="border-top: 1px solid rgba(255, 255, 255, 0.5)">
          <div class="item">
            <div class="itemWord">
              <div class="itemT">单位性质:</div>
              <div class="itemcontent">
                {{ orgType }}
              </div>
            </div>
          </div>
          <div class="item">
            <div class="itemWord">
              <div class="itemT">服务类别:</div>
              <div class="itemcontent" v-if = "serviceCategoryStr.length > 8">
                {{ serviceCategoryStr == null ? "" : serviceCategoryStr.substring(0,9)}}  ...  
              </div>
               <div class="itemcontent" v-else>
                {{ serviceCategoryStr == null ? "" : serviceCategoryStr}}
              </div>
            </div>
          </div>
          <div class="item">
            <div class="itemWord">
              <div class="itemT">负责人（法人）:</div>
              <div class="itemcontent">{{ name }}</div>
            </div>
          </div>
          <div class="item">
            <div class="itemWord">
              <div class="itemT">联系电话:</div>
              <div class="itemcontent">{{ phone }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="item">
            <div class="itemWord">
              <div class="itemT">是否成立党组织:</div>
              <div class="itemcontent">{{ party }}</div>
            </div>
          </div>
          <div class="item">
            <div class="itemWord">
              <div class="itemT">党员人数:</div>
              <div class="itemcontent">{{ partyCount }}</div>
            </div>
          </div>
          <div class="item">
            <div class="itemWord">
              <div class="itemT">党组织联系人:</div>
              <div class="itemcontent">{{ partyName }}</div>
            </div>
          </div>
          <div class="item">
            <div class="itemWord">
              <div class="itemT">党组织联系电话:</div>
              <div class="itemcontent">{{ partyPhone }}</div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="item">
            <div class="itemWord">
              <div class="itemT">是否慈善组织:</div>
              <div class="itemcontent">{{ charitable }}</div>
            </div>
          </div>
          <div class="item">
            <div class="itemWord">
              <div class="itemT">社会组织等级:</div>
              <div class="itemcontent">{{ orgLevel }}</div>
            </div>
          </div>
          <div class="item">
            <!-- <div class="itemWord">
              <div class="itemT">发展指数:</div>
              <div class="itemcontent">{{orgIndex}}</div>
            </div> -->
            <div class="itemWord">
              <div class="itemT">成立时间:</div>
              <div class="itemcontent">{{ orgTime }}</div>
            </div>
          </div>
          <div class="item">
            <div class="itemWord">
              <div class="itemT">是否年检:</div>
              <div class="itemcontent">{{ annualInspection}}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 介绍 -->
      <div class="introduceBox">
        <div class="introLeft">
          <div class="introTit">介绍</div>
          <div class="introCon">
            {{ introduce }}
          </div>
        </div>
        <div class="introRight">
          <div class="radarCon">
            <RadarEchart v-if="isShow"
                         :dataObj="dataArr" />
          </div>
        </div>
        <!--总分 -->
        <div class="sumPointsP">
          <!-- <img src="" alt=""> -->
          <div style="margin-right: 10px; margin-top: 10px">
            <img src="../../assets/socialOrg/latterIcon.png"
                 alt="" />
          </div>
          <div class="pointsBox">
            <span>总分</span>
            <span class="num">{{ sumPoints }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 列表 -->
    <div class="nav">
      <div :class="[selectIndex == index1 ? 'navItem leftA' : 'navItem leftD']"
           class="navItem"
           @click="select(index1)">
        项目({{ sbTotal }})
      </div>
      <div :class="[selectIndex == index2 ? 'navItem rightA' : 'navItem rightD']"
           class="navItem"
           @click="select(index2)">
        活动({{ cjTotal }})
      </div>
    </div>
    <div class="listBox">
      <div v-if="selectIndex == 0 && total > 0"
           class="list">
        <div v-for="(item, index) in projectList"
             :key="index"
             class="item">
          <div class="itemWord1">{{ item.projectName }}</div>
          <div class="itemWord2">
            <img src="../../assets/socialOrg/smallimg.png"
                 alt="" />
            <span>{{ item.address }}</span>
          </div>
          <div v-show="item.projectStatus == 2"
               class="itemWord3">已结项</div>
          <div v-show="item.projectStatus == 1"
               class="itemWord3">执行中</div>
          <div v-show="item.projectStatus == 0"
               class="itemWord3">未开始</div>
        </div>
      </div>
      <div v-if="selectIndex == 1 && total > 0"
           class="list">
        <div v-for="(item, index) in projectList"
             :key="index"
             class="item">
          <div class="itemWord1">{{ item.actName }}</div>
          <div class="itemWord2">
            <img src="../../assets/socialOrg/smallimg.png"
                 alt="" />
            <span>{{ item.address }}</span>
          </div>
          <!-- <div v-if="item.projectStatus==1" class="itemWord3">已结项</div>
        <div v-else class="itemWord3">已结项~</div> -->
        </div>
      </div>
      <div v-if="total == 0"
           style="
          color: #ffe1ce;
          font-size: 35px;
          font-weight: 600;
          margin-top: 80px;
        ">
        暂无相关数据
      </div>
    </div>

    <Pagination v-if="total > 0"
                style="bottom: 40px"
                :total="total"
                :size="2"
                :page="listQuery.page"
                @pagination="fetchData" />
  </div>
</template>

<script>
import RadarEchart from "../../components/SocialRadarEchart.vue";
import Pagination from "@/components/pagination";
import {
  selectKyyOrgDetail,
  kyyProjectStatistics,
  kyyActivityStatistics,
} from "../../config/details";
export default {
  components: { RadarEchart, Pagination },
  data () {
    return {
      // orgId:1131,
      isShow: false,
      projectList: [],
      selectId: {
        id: null,
      },
      total: 90,
      selectIndex: 0,
      index1: 0,
      index2: 1,
      dataArr: {
        type1: [4, 3, 5, 5, 4],
      },
      navArr: [
        { navname: "项目", num: 99 },
        { navname: "活动", num: 76 },
      ],
      orgName: "",
      address: "",
      orgType: "",
      serviceCategory: "",
      name: "",
      phone: "",
      party: "",
      partyCount: "",
      partyName: "",
      partyPhone: "",
      charitable: "",
      orgLevel: "",
      orgIndex: "",
      introduce: "",
      serviceCategoryStr: "",
      annualInspection: "",
      orgTime: "",
      listQuery: {
        page: 1,
        limit: 2,
        orgId: null,
      },
      sbTotal: "",
      cjTotal: "",
      sumPoints: "1000",
    };
  },
  mounted () {
    //  const id = 1131
    const id = this.$route.query && this.$route.query.id;
    this.selectId.id = id;
    this.listQuery.orgId = id;
    this.getDetails();
    this.getsbTotal();
    this.getcjTotal();
    this.fetchData(1);
  },
  methods: {
    select (index) {
      this.selectIndex = index;
      this.listQuery.page = 1;
      this.fetchData(1);
    },

    async getsbTotal () {
      const res = await this.postRequest(kyyProjectStatistics, this.listQuery);
      console.log("res==>", res);
      if (res.rtnCode == "0000") {
        this.sbTotal = res.data.total;
      }
    },
    async getcjTotal () {
      const res = await this.postRequest(kyyActivityStatistics, this.listQuery);
      console.log("res==>", res);
      if (res.rtnCode == "0000") {
        this.cjTotal = res.data.total;
      }
    },

    /**
     * 获取所有数据的方法
     */
    async getDetails () {
      const res = await this.postRequest(selectKyyOrgDetail, this.selectId);
      console.log("res==>", res);
      if (res.rtnCode == "0000") {
        this.orgName = res.data.orgName; //组织名称
        this.address = res.data.address; //地址
        this.orgType = res.data.orgType; //组织类型
        this.serviceCategory = res.data.serviceCategory; //服务类别
        this.name = res.data.name; //负责人
        this.phone = res.data.phone; //电话
        this.party = res.data.party; //是否是党员组织
        this.partyCount = res.data.partyCount; //党员人数
        this.partyName = res.data.partyName; //党组织联系人
        this.partyPhone = res.data.partyPhone; //党组织联系电话
        this.charitable = res.data.charitable; //是否是慈善
        this.orgLevel = res.data.orgLevel; //组织等级
        this.orgIndex = res.data.orgIndex; //组织发展指数
        this.introduce = res.data.introduce; //介绍
        this.serviceCategoryStr = res.data.serviceCategoryStr;
        this.annualInspection = res.data.annualInspection; //是否年检
        this.orgTime = res.data.orgTime; //组织等级
        this.dataArr.type1[0] = res.data.projectIndex;
        this.dataArr.type1[1] = res.data.vitalityIndex;
        this.dataArr.type1[2] = res.data.pioneerIndex;
        this.dataArr.type1[3] = res.data.charitableIndex;
        this.dataArr.type1[4] = res.data.satisfyIndex;
        this.isShow = true;
        this.sumPoints = res.data.sumIndex;
      }
    },
    //获取列表数据
    async fetchData (e) {
      let url;
      if (this.selectIndex == 0) {
        url = kyyProjectStatistics;
      } else {
        url = kyyActivityStatistics;
      }
      console.log("e==>", e);
      this.listQuery.page = e;
      const res = await this.postRequest(url, this.listQuery);
      console.log("res==>", res);
      if (res.rtnCode == "0000") {
        this.projectList = res.data.list;
        this.total = res.data.total;
        console.log("res.data.page=>", e);
      }
    },
    // 返回上一页
    goback () {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="less" scoped>
@rowHeight: 60px; //表格每一行的行高
@bigrowHeight: 150px; //表格每一大行的行高
@centerBoxHeight: 54%; //中间盒子的高度287PX
@titBoxHeight: 24%; //title的盒子高度
@introduceBoxHeight: 200px;
@navHeight: 40px;
.titTop {
  margin-right: 20px;
}
.itemT {
  float: left;
  box-sizing: border-box;
  font-size: 24px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  height: 97.5px;
  line-height: 97.5px;
  margin-left: 30px;
}
.container {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: RGBA(7, 17, 30, 1);
  display: flex;
  align-items: center;
  flex-direction: column;
  header {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 9%;
    width: 100%;
    background: url("../../assets/images/pageHome/topTitle.png") no-repeat
      center/100% 100%;
    position: relative;
    .header_content {
      font-size: 32px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      // background: linear-gradient(to right, #be8840, #ffe01a);
      color: #fff;
      // -webkit-background-clip: text;
      // color: transparent;
    }
    .pageTime {
      position: absolute;
      top: 2.7%;
      right: 10px;
      font-size: 22px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ffe1ce;
    }
    .goback {
      color: #1293f0;
      font-size: 24px;
      position: absolute;
      top: 33.7%;
      right: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      img {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
    }
  }
  .center_box {
    width: 96%;
    border-radius: 15px;
    overflow: auto;
    background: RGBA(8, 34, 62, 1);
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 22px 0;
    margin-bottom: 20px;
    margin-top: 15px;
    .titBox {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      width: 100%;
      height: @titBoxHeight;
      .bigTit {
        color: #fff;
        font-size: 35px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .smallTit {
        color: rgba(255, 255, 255, 1);
        font-size: 27px;
      }
    }
    .introduceBox {
      width: 98%;
      height: @introduceBoxHeight;
      background: rgba(7, 17, 30, 1);
      // background: url("../../assets/socialOrg/introImg1.png") no-repeat
      //   center/100% 100%;
      // box-shadow: 0px 6px 168px 15px RGBA(215, 117, 19, 0.1) inset;

      display: flex;
      margin-top: 15px;
      .introLeft {
        width: 65%;
        display: flex;
        flex-direction: column;
        .introTit {
          width: 84px;
          height: 40px;
          padding-left: 20px;
          background: url("../../assets/socialOrg/introTit.png") no-repeat
            center/100% 100%;
          display: flex;
          // justify-content: center;
          align-items: center;
          color: rgba(255, 255, 255, 1);
          font-size: 24px;
          margin-top: 20px;
          margin-left: 6px;
          margin-bottom: 20px;
        }
        .introCon {
          width: 98%;
          height: 100px;
          margin-left: 18px;
          // padding:5PX 1%;
          color: #fff;
          font-size: 24px;
          line-height: 30px;
          overflow: auto;
          text-overflow: ellipsis;
          white-space: wrap;
        }
        .introCon::-webkit-scrollbar {
          /*滚动条整体样式*/
          width: 0px;
          /*高宽分别对应横竖滚动条的尺寸*/
          height: 0px;
        }

        .introCon::-webkit-scrollbar-thumb {
          /*滚动条里面小方块*/
          border-radius: 6px;
          box-shadow: inset 0 0 0px #efefef;
          -webkit-box-shadow: inset 0 0 0px #efefef;
          /* background: rgba(102, 97, 97, 0.2); */
          background: #efefef;
        }
      }
      .introRight {
        // transform: translateX(-30px);
        width: 27%;
        display: flex;
        justify-content: flex-end;
        cursor: pointer;
      }
      .sumPointsP {
        color: #c1f2fc;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 80px;
        margin-left: 15px;
        // background: pink;
        .pointsBox {
          display: flex;
          flex-direction: column;
          .num {
            color: #fff;
            font-size: 18px;
            font-family: Source Han Sans CN;
            font-weight: 400;
          }
        }
      }
    }
  }
  .nav {
    width: 95%;
    height: @navHeight;
    display: flex;
    align-items: center;
    cursor: pointer;
    .navItem {
      width: 336px;
      height: 54px;
      line-height: 54px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 28px;
    }
    .rightD {
      background: url("../../assets/socialOrg/leftD.png") no-repeat center/100%
        100%;
    }
    .rightA {
      background: url("../../assets/socialOrg/leftA.png") no-repeat center/100%
        100%;
    }
    .leftD {
      background: url("../../assets/socialOrg/rightD.png") no-repeat center/100%
        100%;
    }
    .leftA {
      background: url("../../assets/socialOrg/rightA.png") no-repeat center/100%
        100%;
    }
  }
  .listBox {
    margin-top: 20px;
    border-radius: 15px;
    width: 96%;
    height: 280px;
    background: RGBA(8, 34, 62, 1);
    display: flex;
    // align-items: center;
    justify-content: center;
  }
  .list {
    width: 96%;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 33px;
    .item {
      width: 100%;
      height: 80px;
      background: url("../../assets/socialOrg/listBack.png") no-repeat
        center/100% 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 5px;
    }
    .itemWord1 {
      color: #fff;
      font-size: 30px;
      font-weight: 600;
      margin-left: 20px;
      opacity: 0.8;
    }
    .itemWord2 {
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 26px;
        height: 28px;
        margin-right: 11px;
      }
      font-size: 28px;
      color: #fff;
      opacity: 0.8;
    }
    .itemWord3 {
      font-size: 39px;
      font-weight: 600;
      color: #ffff;
      margin-right: 20px;
    }
  }
}
.table {
  margin: 0 auto;
  width: 98%;
  display: flex;
  flex-direction: column;
  border-top: 0px solid rgba(255, 255, 255, 0.5);
  overflow: hidden;
  font-size: 24px;
  background: #08223e;
  .row {
    width: 99.85%;
    margin-left: 1px;
    height: @rowHeight;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
    border-right: 1px solid rgba(255, 255, 255, 0.5);
    border-left: 1px solid rgba(255, 255, 255, 0.5);
    .item {
      flex: 1;
      height: @rowHeight;
      border-right: 1px solid rgba(255, 255, 255, 0.5);
      display: flex;
      align-items: center;
      color: #fff;
    }
    .item:last-child {
      flex: 1;
      height: @rowHeight;
      border-right: 0px;
    }
    .itemWord {
      display: flex;
      // margin-left: 20px;
      align-items: center;
      .itemcontent {
        color: rgba(255, 255, 255, 1);
        // width: 240px;
        display: flex;
        flex-wrap: wrap;
        margin-left: 30px;
        opacity: 0.6;
        font-size: 23px;
        max-width: 260px;
      }
      .itemT {
        // width:125px;
      }
    }
  }
  .bigrow {
    width: 100%;
    height: @bigrowHeight;
    display: flex;
    // border-bottom: 1px solid rgba(241, 175, 137, 1);
    border-right: 0px solid rgba(241, 175, 137, 1);
    border-left: 0px solid rgba(241, 175, 137, 1);
    border-top: 0px solid rgba(241, 175, 137, 1);
    background: url("../../assets/socialOrg/tableImg.png") no-repeat center/100%
      100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .bigrow_tit1 {
      font-size: 36px;
      color: #fff;
      font-weight: 600;
    }
    .bigrow_tit2 {
      display: flex;
      margin-top: 3px;
      align-items: center;
      justify-content: center;
      opacity: 0.65;
      img {
        width: 26px;
        height: 28px;
        margin-right: 11px;
      }
      font-size: 28px;
      color: #fff;
    }
  }
}
.radarCon {
  width: 300px;
  height: 200px;
  margin-bottom: 5px;
}
</style>
